<template>
  <loading v-if="isLoading"></loading>
  <not-auth
    v-else-if="$status.authorityDepartmentUser === 'NOT_AUTHORIZED'"
  ></not-auth>
  <not-auth v-else-if="user.userInfo.role === 'Admin'"></not-auth>
  <not-auth
    v-else-if="
      getActiveUser.userInfo.departmentUserRole !== 'Admin' &&
      getActiveUser.userInfo.role !== 'Admin'
    "
  ></not-auth>

  <div v-else class="container-fluid">
    <div
      class="float-button"
      @click="saveMultipleAuthorize"
      v-if="multipleAuthorizeList.length > 0"
      :data-text="$t('common.save')"
    >
      <i class="icofont-check"></i>
    </div>
    <div class="o-card o-card__padding-small u-margin-bottom">
      <h4 class="u-margin-bottom-small">
        <i
          class="icofont-arrow-left u-cursor-pointer"
          @click="$router.back()"
        ></i>
        {{ $t("departments.authorizeTitle") }}
      </h4>
      <h5>
        <i class="icofont-user"></i> {{ user.userInfo.fullname }} -
        {{ user.departmentInfo.title }} - {{ user.departmentUserRole }}
      </h5>
      <p>{{ user.userInfo.email }} - {{ user.userInfo.phoneNo }}</p>
      <p>
        <i class="icofont-calendar"></i>
        {{ $t("common.updatedDate") }}: {{ $date.format(user.updatedDate) }}
      </p>
      <p class="o-alert o-alert--info u-margin-top-small">
        <i class="icofont-info-circle"></i>
        {{
          $t("departments.authorizeDescription", {
            department: user.departmentInfo.title,
            user: user.userInfo.fullname,
          })
        }}
      </p>
    </div>
    <div class="u-text-align-right u-margin-bottom-xsmall">
      <Button
        variant="light-danger"
        @click="multipleAuthorizeList = []"
        size="sm"
        v-if="multipleAuthorizeList.length > 0"
        class="u-margin-right-xsmall"
      >
        <i class="icofont-trash"></i>
        {{ $t("common.clear") }}
      </Button>
      <Button
        variant="light-primary"
        @click="chooseAllAuthorize"
        size="sm"
        v-if="multipleSelect"
        class="u-margin-right-xsmall"
      >
        <i class="icofont-check"></i>
        {{ $t("common.chooseAll") }}
      </Button>
      <Button
        :variant="multipleSelect ? 'light-danger' : 'light-primary'"
        @click="multipleSelect = !multipleSelect"
        size="sm"
      >
        <i class="icofont-check"></i>
        {{
          $t(
            !multipleSelect
              ? "common.multipleSelect"
              : "common.closeMultipleSelect"
          )
        }}
      </Button>
    </div>
    <BaseInput
      v-model="search"
      icon="search"
      block
      :placeholder="$t('common.search')"
      :label="$t('common.search')"
    ></BaseInput>
    <div class="row u-background-color-white u-padding-xxsmall">
      <div
        v-for="(item, i) in filteredAuthorizeList"
        :key="item.id"
        class="es-xs-12 es-sm-12 u-align-items-center"
      >
        <h5
          class="u-margin-bottom-small u-margin-top-small"
          v-if="
            i === 0 ||
            item.controller !== filteredAuthorizeList[i - 1]?.controller
          "
        >
          {{ $t(`authority.${item.controller}.mainTitle`) }}
        </h5>
        <div class="c-list__item">
          <div class="u-display-flex u-align-items-center">
            <Checkbox
              v-if="multipleSelect"
              :value="
                multipleSelect ? multipleAuthorizeList.includes(item.id) : false
              "
              @change="selectMultiple(item.id)"
            />
            {{ $t(`authority.${item.controller}.${item.action}`) }}
          </div>
          <div class="u-text-align-center">
            <SwitchButton
              async
              :value="findAuthorize(item.id)"
              @input="(val, loading) => changeAuthorize(item.id, val, loading)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Requests from "@/services/Requests";
import SwitchButton from "@/components/Base/SwitchButton.vue";
import Checkbox from "@/components/Base/Inputs/Checkbox.vue";
import Button from "../Base/Button.vue";
import NotAuth from "../Base/NotAuth.vue";
import BaseInput from "../Base/Inputs/BaseInput.vue";
import { mapGetters } from "vuex";
export default {
  components: { SwitchButton, Checkbox, Button, NotAuth, BaseInput },
  props: {
    userId: {
      default: null,
    },
    departmentId: {
      default: null,
    },
  },
  data() {
    return {
      isLoading: true,
      authorizeList: [],
      multipleAuthorizeList: [],
      user: null,
      userAuthorizeList: [],
      validActivated: false,
      multipleSelect: false,
      search: "",
    };
  },
  computed: {
    ...mapGetters(["getActiveUser"]),
    filteredAuthorizeList() {
      return this.authorizeList.filter((item) => {
        const search = this.search.toLowerCase();
        const itemLabel = this.$t(
          `authority.${item.controller}.${item.action}`
        );
        return itemLabel.toLowerCase().includes(search);
      });
    },
  },
  methods: {
    chooseAllAuthorize() {
      this.multipleAuthorizeList = this.authorizeList.map((item) => item.id);
    },
    selectMultiple(id) {
      const index = this.multipleAuthorizeList.findIndex((item) => item === id);
      if (index === -1) {
        this.multipleAuthorizeList.push(id);
      } else {
        this.multipleAuthorizeList = this.multipleAuthorizeList.filter(
          (item) => item !== id
        );
      }
    },
    async saveMultipleAuthorize() {
      this.$store.dispatch("SET_ACTION_MODAL", {
        isLoading: true,
        status: true,
      });
      const response = await Requests.AuthorityDepartmentUser.CreateMultiple(
        this.multipleAuthorizeList.map((item) => ({
          departmentUserId: this.userId,
          authorityId: item,
        }))
      );
      if (response.message === "OK") {
        this.checkProps();
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t("common.addedSuccessfully"),
          variant: "success",
          duration: 2500,
        });
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`message.${response.message}.description`),
          variant: "danger",
          duration: 2500,
        });
      }
    },
    async changeAuthorize(id, value, loading) {
      loading(true);
      const authorize = this.userAuthorizeList.find(
        (item) => item.authorityInfo.id === id
      );
      console.log(authorize);
      if (authorize) {
        await this.removeAuthorize(authorize);
      } else {
        await this.addAuthorize(id);
      }
      console.log(id, value, authorize);
      loading(false);
    },
    findAuthorize(id) {
      console.log(this.userAuthorizeList, id);

      return this.userAuthorizeList.find((item) => item.authorityInfo.id === id)
        ?.isActive;
    },
    async addAuthorize(id) {
      const response = await Requests.AuthorityDepartmentUser.Create({
        departmentUserId: this.userId,
        authorityId: id,
      });
      if (response.message === "OK") {
        const authority = this.authorizeList.find((item) => item.id === id);
        this.userAuthorizeList.push({
          authorityInfo: authority,
          id: response.data,
          isActive: true,
        });
      }
      return response;
    },
    async removeAuthorize(authorize) {
      const response = await Requests.AuthorityDepartmentUser.Delete({
        params: { id: authorize.id },
      });
      if (response.message === "OK") {
        this.userAuthorizeList = this.userAuthorizeList.filter(
          (item) => item.id !== authorize.id
        );
      }
      return response;
    },
    async save(loading) {
      if (!this.validation()) {
        return;
      }
      loading(true);
      const response = await Requests.Department.Create({
        title: this.title,
        description: this.description,
        isActive: true,
      });
      if (response.message === "OK") {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t("departments.success"),
          variant: "success",
          duration: 2500,
        });
        this.$emit("refresh");
        this.$emit("input", false);
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`message.${response.message}.description`),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
    async update(loading) {
      if (!this.validation()) {
        return;
      }
      loading(true);
      const response = await Requests.Department.Update(
        {
          title: this.title,
          description: this.description,
        },
        { params: { id: this.form.id } }
      );
      if (response.message === "OK") {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t("departments.success"),
          variant: "success",
          duration: 2500,
        });
        this.$emit("refresh");
        this.$emit("input", false);
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`message.${response.message}.description`),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
    validation() {
      if (this.title) {
        return true;
      }
      return false;
    },
    async getAuthorizeList() {
      const response = await Requests.AuthorityDepartmentUser.GetAuthorities();
      if (response.message === "OK") {
        this.authorizeList = response.data.items;
      }
      return response;
    },
    async getUserAuthorizeList() {
      const response = await Requests.AuthorityDepartmentUser.GetAll({
        query: {
          departmentUserId: this.userId,
          departmentId: this.departmentId,
        },
      });
      this.$status.authorityDepartmentUser = response.message;
      if (response.message === "OK") {
        this.userAuthorizeList = response.data.items;
      }
      return response;
    },
    async getDepartmentUser() {
      const response = await Requests.DepartmentUser.GetById({
        params: { id: this.userId },
      });
      if (response.message === "OK") {
        this.user = response.data;
      }
      return response;
    },
    async checkProps() {
      this.isLoading = true;
      await this.getAuthorizeList();
      if (this.userId) {
        await Promise.all([
          this.getUserAuthorizeList(),
          this.getDepartmentUser(),
        ]);
      }
      this.isLoading = false;
    },
  },
  mounted() {
    this.checkProps();
  },
};
</script>

<style scoped></style>
